import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery, pyrotchBaseUrl } from '../axios/AxiosInstance';
import { AxiosResponse } from 'axios';

interface BusinessUnit {
  id: number;
  name: string;
  userId: number | null;
  userName: string;
}

interface BusinessUnitResponse {
  data: BusinessUnit[]; // Adjusted to match the response structure
  message: string;
  status: number;
}

export const BhuApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: pyrotchBaseUrl + 'v1/', // Base URL
  }),
  reducerPath: 'bhuApi',
  tagTypes: ["BHU"],
  endpoints: (build) => ({
    // Define the endpoint for fetching business units
    getBusinessUnits: build.query<BusinessUnit[], void>({
      query: () => ({
        url: 'master-configuration/business-unit/product-types',
        transformResponse: (response: AxiosResponse<BusinessUnitResponse>) => {
          return response.data.data; 
        },
      }),
      providesTags: ["BHU"],
    }),

    updatetheHead: build.mutation<void, { productTypeId: number; userId: number }>({
      query: ({ productTypeId, userId }) => ({
        url: `master-configuration/business-unit/${productTypeId}/update-head?userId=${userId}`, 
        method: 'POST',
      }),
      invalidatesTags: ["BHU"],
    }),
  }),
});

export const { useGetBusinessUnitsQuery, useUpdatetheHeadMutation } = BhuApi;
